import { create } from '@thoughtspot/logger';
import { useBlinkContext } from './blink-context';
const logger = create('Blink Context with Validation for MFE');
const validateService = (mfeName, serviceName, service, contract) => {
    const errorMessagePrefix = `[Blink Context Validation for ${mfeName}] `;
    if (!service) {
        logger.error(`${errorMessagePrefix} ${serviceName} is undefined in blink context`);
    }
    else {
        contract.forEach(({ propName, propType }) => {
            const prop = service[propName];
            if (!prop) {
                logger.error(`${errorMessagePrefix} ${propName} is required in ${serviceName}, but it is undefined.`);
            }
            else if (typeof prop !== propType) {
                logger.error(`${errorMessagePrefix} Expected ${propName} in ${serviceName} to be of type "${propType}" but it is a different type (${typeof prop}).`);
            }
        });
    }
};
export const useBlinkContextWithValidation = (contract) => {
    const { customStylingService, metricsService, navService, sessionService, systemConfigService, webStorageService, ...restProps } = useBlinkContext();
    const validate = (mfeName) => {
        if (contract.customStylingServiceContract) {
            validateService(mfeName, 'customStylingService', customStylingService, contract.customStylingServiceContract);
        }
        if (contract.metricsServiceContract) {
            validateService(mfeName, 'metricsService', metricsService, contract.metricsServiceContract);
        }
        if (contract.navServiceContract) {
            validateService(mfeName, 'navService', navService, contract.navServiceContract);
        }
        if (contract.sessionServiceContract) {
            validateService(mfeName, 'sessionService', sessionService, contract.sessionServiceContract);
        }
        if (contract.systemConfigServiceContract) {
            validateService(mfeName, 'systemConfigService', systemConfigService, contract.systemConfigServiceContract);
        }
        if (contract.webStorageServiceContract) {
            validateService(mfeName, 'webStorageService', webStorageService, contract.webStorageServiceContract);
        }
    };
    const customStylingServiceSubset = customStylingService;
    const metricsServiceSubset = metricsService;
    const navServiceSubset = navService;
    const sessionServiceSubset = sessionService;
    const systemConfigServiceSubset = systemConfigService;
    const webStorageServiceSubset = webStorageService;
    const blinkContextValue = {
        customStylingService: customStylingServiceSubset,
        metricsService: metricsServiceSubset,
        navService: navServiceSubset,
        sessionService: sessionServiceSubset,
        systemConfigService: systemConfigServiceSubset,
        webStorageService: webStorageServiceSubset,
        ...restProps,
    };
    return [validate, blinkContextValue];
};
//# sourceMappingURL=blink-context-with-validation.js.map